import { render, staticRenderFns } from "./DynamicEntityFieldsStatic.vue?vue&type=template&id=18f315f5"
import script from "./DynamicEntityFieldsStatic.vue?vue&type=script&lang=js"
export * from "./DynamicEntityFieldsStatic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports